import ReactAdminContainer from "root/s360components/Administration/ReactAdminContainer";
import LJAppUsageContainer from "root/s360components/LJAppUsage/LJAppUsageContainer";
import './LJAppUsagePage.scss';

const LJAppUsagePage = () =>
{
    return (
        <ReactAdminContainer>
            <LJAppUsageContainer />
        </ReactAdminContainer>
    )
}

export default LJAppUsagePage;
